module.exports = __webpack_public_path__ + "ptc_momoro_A1.0a942355.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_A1.jpg
// module id = vFq1
// module chunks = 0